/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Card, Grid, TextField } from '@mui/material';
import { ChipStatus, DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { IntegrationDTO, MessageDTO, UserDTO, ValueListDTO } from '../../../shared/interfaces';
import { dateDiff, formatDateTime } from '../../../shared/utils';
import { isJsonString } from '../../../shared/utils';
import { tr } from 'date-fns/locale';
import ReactJson from 'react-json-view';

interface IMessageMaintenanceProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const MessageMaintenance: React.FC<IMessageMaintenanceProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [messageContent, setMessageContent] = useState<any>('');
    const [isJson, setIsJson] = useState(false);

    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [flowList, setFlowList] = useState<ValueListDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);

    const [messageDTO, setMessageDTO] = useState<MessageDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setMessageDTO({
            ...messageDTO,
            id: '',
            messageSettingId: '',
            sourceId: '',
            startDateTime: undefined,
            endDateTime: undefined,
            statusId: ListId.linksphere.message.startStatusId
        } as MessageDTO);

        if(isOpenMaintenance){
            handleListGetAll(ListId.linksphere.message.statusId, setStatusList);
            handleListGetAll(ListId.linksphere.message.flowId, setFlowList);
            handleUserGetAllAsync();
            handleGetMessageByIdAsync();
        }
    }, [data, isOpenMaintenance]);

    useEffect(() => {
        if (messageDTO?.content != '')
            handleContentMessageGet(messageDTO?.content.replaceAll('>', '>\n'));
    }, []);

    const handleContentMessageGet = (message: any) => {
        if (isJsonString(message)) {
            setIsJson(true);
            setMessageContent(JSON.parse(message));
        }
        else {
            setIsJson(false);
            setMessageContent(message);
        }
    };

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'value ASC'
        };
        GenericService.GetAllAsync1('parmsphere.valueList', valueListFilterDTO, setLoading, setList, showMessage);
    }, []);

    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            messageId: userInfo.user.messageId,
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);

    }, []);

    const handleGetMessageByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('linksphere.message', data.id, setLoading, setMessageDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = messageDTO as MessageDTO;

        if (messageDTO?.id === '' || messageDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('linksphere.message', dto, setMessageDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('linksphere.message', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [messageDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        // { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'cancel', text: 'Cancel', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='MESSAGE DETAILS'
                icon='grid_view_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <TextFieldReadOnly
                                id={'Integration Id'}
                                label='Integration Id'
                                value={messageDTO?.integrationId}
                                hasDivider={false}
                                hasToolTip={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextFieldReadOnly
                                id={'Correlation Id'}
                                label='Correlatio Id'
                                value={messageDTO?.correlationId}
                                hasDivider={false}
                                hasToolTip={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextFieldReadOnly
                                id={'Siza'}
                                label='Size'
                                value={messageDTO?.size}
                                hasDivider={false}
                                hasToolTip={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextFieldReadOnly
                                id={'flowId'}
                                label='Flow'
                                value={(<ChipStatus label='Flow' value={String(flowList.find(x => x.id === messageDTO?.flowId)?.value || 'Undefined Flow')} />)}
                                hasDivider={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextFieldReadOnly
                                id={'statusId'}
                                label='Status'
                                value={(<ChipStatus label='Status' value={String(statusList.find(x => x.id === messageDTO?.statusId)?.value || 'Undefine Status')} />)}
                                hasDivider={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextFieldReadOnly
                                id={'startDateTime'}
                                label='Start Date Time'
                                value={formatDateTime(String(messageDTO?.creationDateTime))}
                                hasDivider={false}
                                hasToolTip={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextFieldReadOnly
                                id={'deliveryConfirmationDateTime'}
                                label='Delivery Confirmation Date Time'
                                value={formatDateTime(String(messageDTO?.deliveryConfirmationDateTime))}
                                hasDivider={false}
                                hasToolTip={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextFieldReadOnly
                                id={'Elapsed Time'}
                                label='Elapsed Time'
                                value={messageDTO?.creationDateTime ? dateDiff(String(messageDTO.creationDateTime), String(messageDTO.deliveryConfirmationDateTime)) : ''}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextFieldReadOnly
                                id={'hasOnlyKey'}
                                label='Has Only Key'
                                value={(<ChipStatus label='Has Only Key' value={String(messageDTO?.hasOnlyKey)} />)}
                                hasDivider={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            {/* {!isJson === true ? (
                                <Box border={1} borderColor={'gray'} borderRadius={1}>
                                    <ReactJson 
                                        src={messageContent} 
                                        collapsed={true}
                                        enableClipboard={true}
                                    />
                                </Box>
                            ) : ( */}
                            <TextFieldInput
                                id='content'
                                label='Content'
                                value={messageDTO?.content}
                                setValue={setMessageDTO}
                                obj={messageDTO}
                                readonly={true}
                                multiline={true}
                                rows={20}
                            />
                            {/* )} */}
                        </Grid>
                        {messageDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={messageDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label='Created By'
                                        value={userList.find(x => x.id === messageDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label='Creation Date'
                                        value={formatDateTime(String(messageDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label='Updated By'
                                        value={userList.find(x => x.id === messageDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label='Update Date'
                                        value={formatDateTime(String(messageDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};